import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-carousel-item',
    templateUrl: './carousel-item.component.html',
    styleUrls: ['./carousel-item.component.scss'],
    standalone: false
})
export class CarouselItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
